import * as ScrollMagic from "scrollmagic";

function formatNumberWithSpaces(number) {
    let numberString = number.toString();
    let formattedNumber = '';

    // Loop through the string from right to left
    for (let i = numberString.length - 1, count = 0; i >= 0; i--, count++) {
        // Add a space after every three digits
        if (count > 0 && count % 3 === 0) {
            formattedNumber = ' ' + formattedNumber;
        }
        // Add the current digit to the formatted number
        formattedNumber = numberString[i] + formattedNumber;
    }

    return formattedNumber;
}
const counterMixer = () => {
    const controller = new ScrollMagic.Controller();

    const counters = document.querySelectorAll('.countdown-counter__value');
    [...counters].map((item) => {


        const that = item;

        if (!item.dataset.init_txt){
            item.dataset.init_txt = formatNumberWithSpaces(parseInt(that.innerText));
        }

        new ScrollMagic.Scene({ triggerElement: that, triggerHook: 0.9, offset: '0' })
            .on('enter leave', (e) => {
                const triggeringObj = e.currentTarget.triggerElement();

                if (e.type === 'enter') {
                    const transformed =  item.dataset.init_txt.split('');

                    that.innerHTML = ' ';

                    transformed.forEach((item) => {
                        const valueBox = document.createElement('span');
                        that.appendChild(valueBox);
                        let iterator;

                        if (item == ' ') {
                            valueBox.innerHTML = `<span> </span>`;
                        } else if (parseInt(item, 10) <= 9) {
                            const initNo = parseInt(item, 10);
                            let mixedValue = initNo;
                            let loopsCount = 0;
                            function looper() {
                                mixedValue += 1;

                                if (mixedValue > 9) {
                                    mixedValue = 0;
                                    loopsCount += 1;
                                }

                                valueBox.dataset.int_val = mixedValue;
                                valueBox.innerHTML = `<span>${mixedValue}</span>`;

                                if (loopsCount >= ((Math.random() * 5) + 1) && mixedValue === initNo) {
                                    clearTimeout(iterator);
                                } else {
                                    iterator = setTimeout(looper, 10);
                                }
                            }

                            looper();
                        } else {
                            if(item !==' ') {
                                valueBox.innerHTML = item;
                            }

                        }
                    });
                } else if (e.type === 'leave') {
                    triggeringObj.innerHTML =  item.dataset.init_txt;
                }
            }).addTo(controller);
    });

};

export default counterMixer;
